/* @flow */

export type Entity = {
    entityId: string,
    entityName: 'Contacts' | 'Accounts' | 'Users',
    name: string,
    avatarUrl?: string,
    initials: string,
    personName: string[],
    primaryEmailText?: ?string,
    primaryPhoneText?: ?string,
    primaryAddressRegion?: ?string,
    url: string[],
    primaryAccountName?: ?string,
    parentAccountId?: ?string,
    childAccountIds?: string[],
    description?: ?string,
    entityDescription?: ?string,
    jobTitle?: ?string,
};

export type DisplayOptionEntity = {
    id: string,
    value: any,
    type: string,
    avatarUrl: ?string,
    initials: string,
    description: string,
    secondaryInfo: any,
    tertiaryInfo?: any,
    primaryAccountName?: ?string,
    parentAccountId?: ?string,
    childAccountIds?: ?(string[]),
    isDisabled?: boolean,
    disabledText?: string,
    primaryPhoneText?: ?string,
    primaryEmailText?: ?string,
    entityDescription?: ?string,
    jobTitle?: ?string,
};

function getId(entityId: string, entityName: string): string {
    return `${entityId}-${getType(entityName)}`;
}

function getType(entityName: ?string): string {
    return entityName ? entityName.toLowerCase() : '';
}

function getDescription(entityName: ?string): string {
    switch (entityName) {
        case 'Users':
            return 'Nutshell User';
        case 'Accounts':
            return 'Company';
        case 'Leads':
            return 'Lead';
        case 'Teams':
            return 'Team';
        case 'Contacts':
        default:
            return 'Person';
    }
}

function getSecondaryInfo(entity: Entity): ?string {
    if (entity.entityName === 'Contacts') {
        if (entity.jobTitle) {
            return entity.jobTitle;
        } else if (entity.primaryAccountName) {
            return entity.primaryAccountName;
        }
    } else {
        return entity.personName && entity.personName.length ? entity.personName[0] : null;
    }
}

function getTertiaryInfo(entity: Entity): ?string {
    if (entity.entityName === 'Contacts') {
        if (entity.primaryEmailText) {
            return entity.primaryEmailText;
        } else if (entity.primaryPhoneText) {
            return entity.primaryPhoneText;
        }
    } else if (entity.entityName === 'Accounts') {
        if (entity.primaryAddressRegion) {
            return entity.primaryAddressRegion;
        } else if (entity.url && entity.url.length > 0) {
            return entity.url[0];
        }
    }

    return null;
}

export function mapEntityToDisplayOption(entity: Entity): Object {
    return {
        id: getId(entity.entityId, entity.entityName),
        value: entity.name,
        type: getType(entity.entityName),
        avatarUrl: entity.avatarUrl,
        initials: entity.initials,
        description: getDescription(entity.entityName),
        entityDescription: entity.description,
        secondaryInfo: getSecondaryInfo(entity),
        tertiaryInfo: getTertiaryInfo(entity),
        parentAccountId: entity.parentAccountId,
        childAccountIds: entity.childAccountIds || [],
        primaryPhoneText: entity.primaryPhoneText,
        primaryAccountName: entity.primaryAccountName,
        primaryEmailText: entity.primaryEmailText,
        jobTitle: entity.jobTitle,
    };
}
